var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 127,
    viewBox: "0 0 136 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.9487,
    cy: 83.6582,
    r: 2.9801,
    transform: "rotate(-41.0718 70.9487 83.6582)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.2048,
    cy: 92.0873,
    r: 2.9801,
    transform: "rotate(-41.0718 52.2048 92.0873)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.307,
    cy: 14.3292,
    r: 2.9801,
    transform: "rotate(-41.0718 113.307 14.3292)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.933,
    cy: 28.1754,
    r: 2.9801,
    transform: "rotate(-41.0718 111.933 28.1754)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.922,
    cy: 43.5304,
    r: 2.9801,
    transform: "rotate(-41.0718 107.922 43.5304)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.8073,
    cy: 59.3798,
    r: 2.9801,
    transform: "rotate(-41.0718 98.8073 59.3798)",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.8359,
    cy: 73.7656,
    r: 2.9801,
    transform: "rotate(-41.0718 86.8359 73.7656)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0146 96.1224C16.822 95.3735 16.7563 93.6593 17.8881 92.8213L30.8482 83.2255C32.14 82.269 33.9752 83.1501 34.0368 84.7563L34.7333 102.928C34.7948 104.534 33.0324 105.553 31.6711 104.698L18.0146 96.1224Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMobile);
export default __webpack_public_path__ + "static/media/arrowMobile.a1ead9a5c7b177504a99ac3e232a4752.svg";
export { ForwardRef as ReactComponent };